import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme: { spacing, breakpoint } }) => css`
    display: grid;
    grid-template-columns: 100%;
    grid-auto-rows: max-content;
    grid-gap: ${spacing.km3};
    padding: ${spacing.km6} ${spacing.km6} ${spacing.km16} ${spacing.km6};
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;

    @media screen and (min-width: ${breakpoint.md.minWidth}) {
      padding: ${spacing.km12};
    }
  `}
`;
